import { RealmType } from '../enums/realm-type.enum';
import { ServerPermission } from '../enums/server-permission.enum';

export const REALM_HIERARCHY_MEDIA_TYPE = 'application/vnd.io.idaas.admin.api.realm.hierarchy.v1+json';

export class RealmHierarchy {
  public id: string;
  public type: RealmType;
  /* The realm's enterprise code if enterprise realm */
  public code?: string;
  public name: string;
  /* The possible permissions for this realm*/
  public permissions: ServerPermission[];
  public subRealms?: RealmHierarchy[];

  constructor(backEndAccount?: BackEndRealmHierarchy) {
    if (backEndAccount) {
      this.id = backEndAccount.id;
      this.type = backEndAccount.type;
      this.code = backEndAccount.code;
      this.name = backEndAccount.name;
      this.permissions = backEndAccount.permissions;
      this.subRealms = backEndAccount.sub_realms?.map(subrealm => new RealmHierarchy(subrealm));
    }
  }

  public static findRealm(hierarchy: RealmHierarchy, realmId: string): RealmHierarchy | null {
    if (hierarchy.id === realmId) {
      return hierarchy;
    }

    if (!hierarchy.subRealms) {
      return null;
    }

    for (const subrealm of hierarchy.subRealms) {
      const foundRealm = this.findRealm(subrealm, realmId);
      if (foundRealm) {
        return foundRealm;
      }
    }

    return null;
  }

    public static findRealmAncestors(hierarchy: RealmHierarchy, realmId: string): RealmHierarchy[] | null {
    if (hierarchy.id === realmId) {
      return [hierarchy];
    }

    if (!hierarchy.subRealms) {
      return null;
    }

    for (const subrealm of hierarchy.subRealms) {
      const foundRealms = this.findRealmAncestors(subrealm, realmId);
      if (foundRealms) {
        return [hierarchy, ...foundRealms];
      }
    }

    return null;
  }
}

export interface BackEndRealmHierarchy {
  id: string;
  type: RealmType;
  code: string;
  name: string;
  permissions: ServerPermission[];
  sub_realms?: BackEndRealmHierarchy[];
}
